module.exports = __webpack_public_path__ + "img/org5.99974a1b.png";